module.exports = __webpack_public_path__ + "static/media/HeaderHome.99c357c5.png";